import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { useConfiguration } from '../../hooks/Configuration';

interface IWebchatProps {
    small?: boolean
}

const TITLE = 'Chatovat s operátorem';

const useWebchat = () => {
    const [webchatElement, setWebchatElement] = useState<HTMLElement | null>(document.getElementById('icc3-chat-mini-header-agent'));

    useEffect(
        () => {
            if (webchatElement) return;

            const timer = setInterval(
                () => {
                    const element = document.getElementById('icc3-chat-mini-header-agent');
                    // console.log('check', element);

                    if (!element) return;

                    clearInterval(timer);
                    setWebchatElement(element);
                },
                100
            );

            return () => clearInterval(timer);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const clickHandler = useCallback(
        () => {
            webchatElement && webchatElement.click();
            document.getElementById('stx-chat-close')?.click();
        },
        [webchatElement]
    );

    return { clickHandler, webchatElement };
}

function Webchat({ small }: IWebchatProps) {
    const { webchatElement, clickHandler } = useWebchat();
    const configuration = useConfiguration();

    if (!webchatElement) return (null);

    return (
        small ?
            <button
                style={{
                    backgroundColor: configuration?.styles.btnSendBgColor,
                    color: configuration?.styles.btnSendColor
                }}
                title={TITLE}
                onClick={clickHandler}>
                <FontAwesomeIcon
                    icon={icon({ name: 'message' })}
                    size='lg' />
            </button> :
            <button
                className='stx-chat-faq'
                style={{
                    backgroundColor: configuration?.styles.faqBgColor,
                    color: configuration?.styles.faqTextColor
                }}
                onClick={clickHandler}>
                {TITLE}
            </button>
    );
}

interface IWebchatTagProps {
    children: any
}

export function WebchatTag({ children }: IWebchatTagProps) {
    const { webchatElement, clickHandler } = useWebchat();

    return (
        <button
            className='text-link tag-use'
            onClick={webchatElement ? clickHandler : undefined}>
            {children}
        </button>
    );
}

export default Webchat;
